<template>
    <div class="products-website">
        <g-typography tag="p" value="Head to our website and select the products you’d like to receive." />
        <!-- TODO: turn `panel-drop` into component or find where it's used elsewhere if it already exists -->
        <div class="panel-drop">
            <div class="header">
                <g-icon class="icon" name="chevron-down" />
                <g-typography class="title" tag="h4" font-weight="semibold" value="Instructions" />
            </div>
            <div class="content">
                <!-- TODO: turn into `g-typography` and have it support needed colors and sizes -->
                <ol>
                    <li>Go to our website: <a :href="storeUrl" class="link" target="_blank">{{ storeUrlDisplay }}</a></li>
                    <li>Browse our catalog and add the items you’d like to receive to your cart.</li>
                    <template v-if="selectionMethodWebsiteShopifySharedCart">
                        <li>Go to the cart page.</li>
                        <li>Click the Share Cart button to copy the URL, and paste it below.</li>
                    </template>
                    <template v-else>
                        <li>Go to the first step of checkout.</li>
                        <li>Copy the URL, and paste it below.</li>
                    </template>
                </ol>
                <div class="sample">
                    <div>The link should look similar to this:</div>
                    <template v-if="selectionMethodWebsiteShopifySharedCart">
                        <div>{{ storeUrlDisplay }}/shared-cart/197659668480:1,196142759117:2</div>
                    </template>
                    <template v-else>
                        <div>{{ storeUrlDisplay }}/12321/checkouts/bs10d09n or {{ storeUrlDisplay }}/checkouts/c/bs10d09n/information</div>
                    </template>
                </div>
            </div>
        </div>
        <div class="large-input">
            <g-input v-model="checkoutUrl" :class="{'error-input': showError}" placeholder="Checkout URL" />
            <g-button class="confirm" type="primary" :loading="isLoadingProducts" @click="handleURLSubmit"> Confirm </g-button>
        </div>
        <g-typography v-if="showError" color="error"> Oops, wrong URL. Let's try this again. </g-typography>
    </div>
</template>

<script>
    import {get} from 'lodash';
    import ActivationBriefProductConfigMixin from '../../mixins/ActivationBriefProductConfigMixin';
    import ActivationBriefProductsMixin from '../../../../providers/mixins/ActivationBriefProductsMixin';

    export default {
        name:   'ProductsWebsite',
        mixins: [
            ActivationBriefProductConfigMixin,
            ActivationBriefProductsMixin,
        ],
        data() {
            return {
                checkoutUrl: null,
                showError:   false,
            };
        },
        computed: {
            storeUrlDisplay() {
                return get(this.brief, 'brand.website_url', '').replace(/\/$/, '');
            },
            storeUrl() {
                return this.storeUrlDisplay.startsWith('http') ? this.storeUrlDisplay : `//${this.storeUrlDisplay}`;
            },
        },
        methods: {
            handleURLSubmit() {
                this.showError = false;
                this.getProductsFromCheckoutUrl(this.brief.id, this.checkoutUrl).then(products => {
                    if (products) {
                        this.$emit('selected', products, products.map(product => this.findProductVariantOptionValues(product.variants, product.variant_id)));
                    }
                }).catch(() => this.showError = true);
            },
            findProductVariantOptionValues(variants, variantId) {
                const variant = variants.find(item => item.id === variantId);

                return variant ? variant.option_values.map(this.transformOptionValues) : [];
            },
            transformOptionValues(optionValue) {
                return {
                    value_id: optionValue.id,
                    id:       optionValue.option_id,
                    name:     optionValue.name,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
.products-website {
    .panel-drop {
        margin-top: 30px;
        width: 100%;
        border: 1px #D7DBDF solid;
        border-radius: 4px;
        overflow: hidden;
        .header {
            background-color: #F9FAFB;
            height: 46px;
            display: flex;
            align-items: center;
            font-size: 15px;
            border-bottom: 1px #D7DBDF solid;
            padding: 0 24px;
            cursor: pointer;
            .icon {
                position: relative;
                font-size: 13px !important;
            }
            .title {
                margin-left: 4px;
            }
        }
        .content {
            padding: 8px 24px;
            .link {
                color: $g-color-primary;
            }
            ol {
                position: relative;
                left: -10px;
            }
            .sample {
                font-size: 12px;
                color: #636A71;
            }
        }
    }
    .large-input {
        margin-top: 20px;
        height: 40px;
        width: 100%;
        display: flex;
    }
    .error-input {
        border-color: $g-font-color-error;
    }
}
</style>
